import { useState } from "react";
import { API_UPLOAD_IMG, BASE_API, BASE_URI } from "../constants/api";
import { RequestError } from "../errors/RequestError";
import { UploadResponseType } from "../types/upload";
import useAuth from "./useAuth";



const useUploadImage = () => {
  const {token} = useAuth();
  
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState<UploadResponseType|null>(null);
  const [error, setError] = useState<Error|null>(null);

  const upload = (file: File) => {

    const headers = new Headers();
    
    if (!token) {
      const errorToken = new RequestError("Vous n'êtes pas autorisé à uploader une image", 401);
      setError(errorToken);
      return;
    }
    headers.set('Authorization', 'Bearer ' + token);

    const formData = new FormData();
    formData.append("image", file);

    setLoading(true);
    setError(null);
    setResponse(null);
    fetch(`${BASE_URI}/${BASE_API}/${API_UPLOAD_IMG}`, {
      method: 'POST',
      body: formData,
      headers,
      mode: 'cors'
    })
    .then(async (response) => {
      if (response.ok) {
        return response.json()
      } else {
        return response.text().then(text => {
          const error = JSON.parse(text);
          throw new RequestError(error.message ?? "Erreur lors de l'upload", response.status);
        });
      }
    })
    .then((data: UploadResponseType) =>  setResponse(data))
    .catch((error) => {setError(error); setResponse(null)})
    .finally(() => setLoading(false))
  }

  return {loading, error, response, upload}
}

export default useUploadImage;